import React, {useEffect, useState} from "react";
import axios from "axios";

const NieuweLMBLogging = () => {
    const [formData, setFormData] = useState({
        organization: 'first',
        loggerid: '',
        alias: '',
    });
    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {
        const fetchOrganizations = async () => {
            const response = await axios.get(`/api/organization/get/berende`, {});

            await setOrganizations(response.data);
        };

        fetchOrganizations();
    }, [])



    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const Nieuw = async () => {
        const response = await axios.get(`/api/berend/new`, {
        params: {
            organization: formData.organization,
            loggerid: formData.loggerid,
            alias: formData.naam,
            clean: organizations.find(element => element.name === formData.organization).clean
        }
        });

        console.log(response.data);
    };

    const formList = ["loggerid", "naam"]

    return (
        <div className={"pl-14 pr-14 flex flex-col items-center gap-10 p-2"}>
            <div className="flex w-full h-full justify-center gap-10">
                <dialog id={"loading"} open className={"top-52 z-50 text-center text-9xl p-10 rounded-lg shadow-xl bg-white select-none hidden flex-col gap-10"}>
                    Laden...
                    <h1 className={"text-2xl"}>dit kan even duren</h1>
                </dialog>
                <div className="flex w-2/6 flex-col items-center gap-5 bg-white rounded-md shadow-lg p-8">
                    <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>Maak Een Nieuwe LMB Logging Machine</h1>
                    <form onSubmit={Nieuw} id={"form"} className="flex flex-col items-center gap-4 rounded-md justify-center w-full">
                        <div className="w-full flex flex-col gap-1">
                            <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Organisatie</h1>
                            <select className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" onChange={handleChange} name={"organization"} value={formData.organization}>
                                <option disabled={true} hidden={true} value="first">Kies Een Organisatie</option>
                                {organizations.map((organization) => (
                                    <option className={"text-gray-500 text-xl"} key={organization._id} value={organization.name}>
                                        {organization.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {formList.map((name) => (
                            <div className="w-full flex flex-col gap-1" key={name}>
                                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>{name.toLocaleUpperCase()[0] + name.slice(1).replace("_", " ")}</h1>
                                <input
                                    className="w-full text-xl p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal"
                                    type="text"
                                    placeholder={"Vul " + name.toLocaleUpperCase()[0] + name.slice(1).replace("_", " ") + " In"}
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        ))}
                        <input
                            className="w-fit text-2xl text-center rounded-md py-2 px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"
                            type="submit" value={"Maak Machine"}
                        />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NieuweLMBLogging;